export default __webpack_public_path__ + "static/media/Proxy_Vote_Icon.f5b6c95f.svg";